import { gql } from '@apollo/client';

export const QUERY_CLIENT_ACCESSGROUPSV2 = gql`
  query AccessGroupsv2 {
    accessGroupsv2 {
      id
      name
      description
      members {
        user {
          id
          firstName
          lastName
        }
        roles {
          id
          key
          name
          description
          permissions
          owned {
            clientId
            visibility
          }
        }
        isSuperAgAdmin
      }
      resources {
        ... on Templatev2 {
          id
          name
        }
        ... on Questionv2 {
          id
          shortDescription
          text
        }
      }
    }
    member: viewer {
      isAdmin
      isSuperAgAdmin
      accessGroupRoles {
        accessGroupId
        roles {
          id
          name
          description
          permissions
        }
        isLocalAdmin
      }
      client {
        members {
          totalCount
          nodes {
            id
            firstName
            lastName
            flag
          }
        }
      }
    }
    allRoles: rolesv2 {
      id
      key
      name
      description
      permissions
      owned {
        visibility
        clientId
      }
    }
  }
`;
